jQuery(document).ready(function($) {
    
    $('#front-page-menu a').on('click', function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      var yPosition = $(target).offset().top - 80;
      $('html').velocity('scroll', {duration: 350, offset:yPosition});
    });
    
    function sticky_topnav(e){
        var breakpointY = 16;
        
        if( $(document).scrollTop() > breakpointY ){
            $('#topnav').removeClass('bg-transparent').addClass('bg-primary');
        }else{
            $('#topnav').removeClass('bg-primary').addClass('bg-transparent');
        }
    }
    $(window).on('load scroll resize', _.debounce(sticky_topnav, 150));
    
});
